var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-primary border-0 rounded-0",attrs:{"id":"cookie-revoke-button","href":"javascript:void(0);","aria-label":"View cookie settings","data-cc":"c-settings"}},[_c('span',{staticClass:"cookie-revoke-icon"},[_c('i',{staticClass:"fa fa-fingerprint fa-2x"})])])
}]

export { render, staticRenderFns }